import { AgencyCapacityFillingStatus, AgentWorkload } from '../../types';

export enum AgentWorkloadReminderType {
    NoFeedbackForTwoWeeks = 'NoFeedbackForTwoWeeks',
    OverloadedForTwoDays = 'OverloadedForTwoDays',
}

export enum AgencyCapacityReminderType {
    CapacityNeedToBeFilled = 'CapacityNeedToBeFilled',
}

export type CollectCapacityReminderType = AgentWorkloadReminderType | AgencyCapacityReminderType;

export type CollectCapacityReminder = {
    type: CollectCapacityReminderType;
    remindAt: Date;
};

// eslint-disable-next-line sonarjs/redundant-type-aliases -- semantic domain type, intentionally kept
export type AgentWorkloadReminder = CollectCapacityReminder;

export type AgencyCapacityReminder = CollectCapacityReminder & {
    relatedMonth: number; // 0 based (0 = january, 11 = december)
};

export type CollectCapacityReminderContext = {
    agentWorkload: AgentWorkload | null;
    agencyCapacityFillingStatus: AgencyCapacityFillingStatus;
};

interface CollectCapacityReminderConfigurator {
    support(context: CollectCapacityReminderContext): boolean;
    get(context: CollectCapacityReminderContext): CollectCapacityReminder | null;
}

export interface AgencyCapacityReminderConfigurator extends CollectCapacityReminderConfigurator {
    get(context: CollectCapacityReminderContext): AgencyCapacityReminder | null;
}

export interface AgentWorkloadFeedbackReminderConfigurator extends CollectCapacityReminderConfigurator {
    get(context: CollectCapacityReminderContext): AgentWorkloadReminder | null;
}
